var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-projects-menu-container display-flex flex-column flex-align-start height-100",class:{ 'is-open': _vm.isOpen }},[(_vm.isOpen)?[_c('PinProjectMenuButton',{staticClass:"pin-button-container"}),_c('h3',{staticClass:"mb-6"},[_vm._v("Create and manage")]),_c('ProjectMenu',{attrs:{"fullPage":""}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }